import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotTravelTimesApiMeta } from "../apiMeta";
import {
  type TravelTimeByIdInput,
  travelTimeByIdInputSchema,
} from "./shared/travelTimeRoutes.input";
import {
  type TravelTimeRoute,
  travelTimeRouteSchema,
} from "./shared/travelTimeRoutes.output";

/**
 * Metadata for the fetchTravelTimeById endpoint
 */
export const travelTimeByIdMeta = {
  functionName: "fetchTravelTimeById",
  endpoint: "/getTravelTimeAsJson?TravelTimeID={TravelTimeID}",
  inputSchema: travelTimeByIdInputSchema,
  outputSchema: travelTimeRouteSchema,
  sampleParams: { TravelTimeID: 1 },
  endpointDescription: "Get travel time data for a specific route by ID.",
} satisfies EndpointMeta<TravelTimeByIdInput, TravelTimeRoute>;

/**
 * Fetch function for retrieving travel time data for a specific route by ID
 */
const { fetch, useHook } = createFetchAndHook<
  TravelTimeByIdInput,
  TravelTimeRoute
>({
  api: wsdotTravelTimesApiMeta,
  endpoint: travelTimeByIdMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/travelTimeRoutes.endpoints").travelTimeRoutesGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving travel time data for a specific route by ID
 */
export const fetchTravelTimeById: FetchFactory<
  TravelTimeByIdInput,
  TravelTimeRoute
> = fetch;

/**
 * React Query hook for retrieving travel time data for a specific route by ID
 */
export const useTravelTimeById: HookFactory<
  TravelTimeByIdInput,
  TravelTimeRoute
> = useHook;
